import { productAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import { actionsStyles } from "@insite/content-library/Widgets/ProductList/ProductListActions";
import { productListCategoryFiltersStyles } from "@insite/content-library/Widgets/ProductList/ProductListCategoryFilters";
import List from "@insite/mobius/Icons/List";
import { css } from "styled-components";
import { productAttributesStyles } from "@insite/content-library/Components/ProductAttributes";
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";

// add icon next to PLP add to list link
productAddToListLinkStyles.link = {
    icon: {
        iconProps: {
            src: List,
            size: 20,
            css: css`
                margin-left: 6px;
            `,
        },
        position: "right",
    },
};

productListCategoryFiltersStyles.accordionSection = {
    headerProps: {
        css: css`
            button {
                background-color: #ffd100;
                :focus {
                    border: 1px solid black !important;
                }
            }
        `,
    },
};

actionsStyles.addToCartButton = {
    css: css`
        width: 80%;
        color: black;
        text-transform: uppercase;
    `,
};

productAttributesStyles.attributeTypeGridItem = {
    width: 6,
    css: css`
        width: auto !important;
    `,
};

productAttributesStyles.attributeValueGridItem = {
    width: 6,
    css: css`
        border-collapse: collapse;
    `,
};

productAttributesStyles.attributeValueText = {
    css: css`
        margin-left: 5px;
    `,
};

columnsStyles.leftColumnGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        max-height: 100%;
        > div:first-child {
            height: 100%;
        }
    `,
};